import {useRef} from 'react';

// Returns the latest value seen while not frozen, so the result stays unchanged until the freeze ends
export const useFrozenValueWhile = <T>(value: T, isFrozen: boolean): T => {
  const frozenValue = useRef(value);

  if (!isFrozen) frozenValue.current = value;

  return frozenValue.current;
};
